import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { pipe } from "rxjs";
import { map } from "rxjs/operators";
import { ROUTES_CONFIG } from "src/app/config";
import { ModalService } from "../../modal/services/modal.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  private readonly headerRoutesTitles = {
    [ROUTES_CONFIG.PROFILE_PERSONAL_INFORMATION.ROUTE]: "პირადი ინფორმაცია",
    [ROUTES_CONFIG.PROFILE_CHANGE_PASSWORD.ROUTE]: "პაროლის შეცვლა",
    [ROUTES_CONFIG.PROFILE_BANK_DETAILS.ROUTE]: "საბანკო რეკვიზიტები",
    [ROUTES_CONFIG.PROFILE_MY_AUCTIONS.ROUTE]: "ჩემი აუქციონი",
    [ROUTES_CONFIG.PROFILE_FAVORITES.ROUTE]: "ფავორიტები",
    [ROUTES_CONFIG.PROFILE_NOTIFICATIONS.ROUTE]: "შეტყობინებები",
    [ROUTES_CONFIG.PROFILE_TRANSACTION_HISTORY.ROUTE]: "ტრანზაქციების ისტორია",
  };

  private readonly navbarComponentName: string = "ProfileNavbarComponent";

  private generatedHeaderTitle: string;

  constructor(
    private router: Router,
    private modalService: ModalService,
  ) {
    this.generateHeaderTitle();
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.generateHeaderTitle();
      }
    });
  }

  generateHeaderTitle(): void {
    const eventUrlLastPart = this.router.url.split("/");
    this.generatedHeaderTitle =
      this.headerRoutesTitles[eventUrlLastPart[eventUrlLastPart.length - 1]];
  }

  openNavigationModal(): void {
    this.modalService.load({ name: this.navbarComponentName });
  }

  get getGeneratedHeaderTitle() {
    return this.generatedHeaderTitle;
  }
}
